import React from "react";
import "./Dropdown.scss";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { TreeSelect } from "antd";
import Loader from '@material-ui/core/CircularProgress';

interface OptionDTO {
  title: string;
  value: string;
  parentId: number;
  children?: OptionDTO[];
  key: string;
}

interface DropdownProps {
  options: OptionDTO[];
  treeLine: boolean;
  treeCheckStrictly: boolean; //if true can select companies without select parents and reverse
  menuSearch?: React.ReactNode;
  additionalIcon?: React.ReactNode;
  onOptionSelected: Function;
  placeholder: string;
  style: React.CSSProperties;
  dropdownStyle: React.CSSProperties;
  onChange: Function;
  onSelect: Function;
  onClear?: Function;
  value: string[] | undefined | number | number[] | string;
  treeCheckable: boolean;
  colorScheme?: "blue" | "purple" | "gray" | "green" | "gold";
  treeNodeFilterProp: string; // default = title. to select champs for research
  multiple: boolean;
  showSearch: boolean;
  allowClear: boolean;
  filterTreeNode?: (inputValue: string, treeNode: any) => boolean;
  disabled?: boolean,
  onSearch?: Function,
  defaultValue: string | {},
  loading: boolean,
  key: any,
}

const Dropdown: React.FC<DropdownProps> = ({
  options,
  treeLine = false,
  treeNodeFilterProp = "title",
  style,
  placeholder,
  onChange,
  onSelect,
  treeCheckStrictly = false,
  value,
  treeCheckable = true,
  multiple = false,
  showSearch = true,
  allowClear = true,
  onClear,
  menuSearch,
  additionalIcon,
  onOptionSelected,
  dropdownStyle,
  filterTreeNode,
  colorScheme = "blue",
  disabled = false,
  onSearch = () => {},
  defaultValue,
  selectedOption,
  loading = false,
  key,
  ...props
}) => {

  const returnNoDataContent = () => {
    if(selectedOption) {
      if(selectedOption.value.toLowerCase() === 'inies') {
        if(loading) {
          return(
            <div className="wrapper-nodata"> <Loader
    variant="indeterminate"
    disableShrink
    style={{ color: "#73b7ec" }}
    size={30}
    thickness={4}
  /></div>
          )
        } else {
  return(
  <div className="wrapper-nodata">Taper un ID ou un nom de fiche INIES</div>
  )
        }
      } else {
        return(
  <div className="wrapper-nodata">Aucun résultat</div>
        )
      }
    }
   
  }
  return (
    <div className="dropdownComponent" >
      <TreeSelect
        {...props}
        disabled={disabled}
        key={key || defaultValue}
        defaultValue={defaultValue}
        treeData={options}
        onSearch={onSearch}
        loading={loading}
        placeholder={placeholder}
        style={style}
        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
        treeCheckable={treeCheckable}
        treeCheckStrictly={treeCheckStrictly}
        treeNodeFilterProp={treeNodeFilterProp}
        value={value || undefined}
        onChange={onChange}
        showArrow={true}
        treeLine={treeLine}
        notFoundContent={returnNoDataContent()}
        // treeDefaultExpandAll={true}
        onSelect={(companyId, company) => {
          onSelect(companyId, company);
        }}
        onClear={(e) => {
          if (onClear) {
            onClear(e);
          } else {
            onChange(selectedOption.value)
          }
        } }
        showSearch={showSearch}
        allowClear={allowClear}
        filterTreeNode={filterTreeNode}

        // filterTreeNode={true}
      />
    </div>
  );
};

export default Dropdown;
